import { gql } from '@apollo/client';

export const BALANCE_UPDATED_SUBSCRIPTION = gql`
  subscription BalanceUpdated($userId: Int!) {
    balanceUpdated(userId: $userId) {
      id
      username
      name
      email
      phone
      credit
      isActive
      parentId
      comment
      lastLogin
      loginIp
      avatarUrl
      language
      timezone
      createdAt
      updatedAt
      totalActiveBonus
      wagerBonus
      dailyBonus
      hourlyBonus
      balanceIn
      balanceOut
      profit
      hold
      holdPercentage
      role {
        id
        name
      }
      Balance {
        id
        amount
        credit
        onHold
      }
    }
  }
`;
